var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1751_6605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "var(--primary-700)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7369 28.0008C36.8388 12.3383 19.1638 12.3383 8.26562 28.0008C19.1638 43.6633 36.8388 43.6633 47.7369 28.0008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8551 34.8606C38.6441 31.0716 38.6441 24.9284 34.8551 21.1394C31.0661 17.3505 24.923 17.3505 21.134 21.1394C17.345 24.9284 17.345 31.0716 21.134 34.8606C24.923 38.6495 31.0661 38.6495 34.8551 34.8606Z",
    fill: "#E48E45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3714 31.3777C33.2368 29.5122 33.2368 26.4878 31.3714 24.6223C29.5059 22.7569 26.4814 22.7569 24.616 24.6223C22.7505 26.4878 22.7505 29.5122 24.616 31.3777C26.4814 33.2431 29.5059 33.2431 31.3714 31.3777Z",
    fill: "#1C2011"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4714 23.7578C24.1562 23.7578 23.8482 23.8513 23.5862 24.0265C23.3242 24.2017 23.1201 24.4507 22.9997 24.7419C22.8793 25.0332 22.848 25.3536 22.9098 25.6626C22.9716 25.9716 23.1237 26.2554 23.3469 26.4779C23.57 26.7005 23.8542 26.8518 24.1634 26.9128C24.4726 26.9737 24.7929 26.9415 25.0839 26.8203C25.3748 26.6991 25.6232 26.4943 25.7976 26.2319C25.9721 25.9694 26.0648 25.6611 26.0639 25.3459C26.0639 25.137 26.0227 24.9301 25.9426 24.7372C25.8625 24.5442 25.7451 24.3689 25.5972 24.2214C25.4493 24.0739 25.2737 23.957 25.0805 23.8774C24.8873 23.7979 24.6803 23.7572 24.4714 23.7578Z",
    fill: "#EBF0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1751_6605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b7625cf5368f0dd3a7cea64a4932b6f0.svg";
export { ForwardRef as ReactComponent };